// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root___cjx9","header":"ReportDetails_header__24nkN","title":"ReportDetails_title__3y0Ot","left":"ReportDetails_left__2-Z1z"};